import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { __await } from "tslib";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { InvoicePreviewComponent } from "../invoice-preview/invoice-preview.component";
@Component({
  selector: "app-invoice-list",
  templateUrl: "./invoice-list.component.html",
  styleUrls: ["./invoice-list.component.css"],
})
export class InvoiceListComponent implements OnInit {
  rr: any = [];
  dtOptions: any = {};
  receipts: any[] = [];
  genLr: any[] = [];
  EmailLr: any[] = [];
  lrByEmail: any[] = [];
  invoiceType: any;
  clientList: any[] = [{}];
  invoiceList: any = [{}];
  lrNumber: any[] = [];
  dropdownSettings;
  generatedLrs: any = [];
  actualData;
  clientName: any = [];
  extractLrNoFromActualData = [];
  filterform = new FormGroup({
    clientName: new FormControl("", [Validators.required]),
    invoiceType: new FormControl("", [Validators.required]),
    LR_no: new FormControl("", [Validators.required]),
  });
  clientIds: any = [];
  billno: string = '';
  invtot: any;
  tooltaxPaidtot: any;
  extrahour: any;
  kmtot: any;
  totLabourLoad: number = 0;
  totLabourUnload: number = 0;
  totDetention: number = 0;
  Frieght: number = 0;
  transporterName: string = '';
  transporterAddress: string = '';
  transporterGstNo: string = '';
  otherPayment: number = 0;
  totalAmountInAdhoc: number = 0;
  checkInvoiceType: any = 'Ad Hoc';
  isAdHoc: boolean = false;
  isEditing: boolean = false;
  users: any = [];
  isAdmin: boolean = false;
  displayedColumns: any = ["sno", "billNumber", "clientName", "created_date", "action"];
  @ViewChild("paginator") paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;
  @ViewChild(MatSort) sort: MatSort;

  private invoicePreviewRef: MatDialogRef<InvoicePreviewComponent>;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.getlrs();
    this.getInvoiceTypes();
    this.getClientList();
    this.lrNumber = [];
    // this.dtOptions = {
    //         pagingType: 'full_numbers'
    //       };
    this.filterform.controls["LR_no"].setValue(null);
  }
  ngAfterViewInit() { }
  getClientList() {
    this.superAdminService
      .getClientList()
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status !== true) {
          if (res.status == 401) {
            this.toastr.error(res.message);
            this.spinner.hide();
            sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.spinner.hide();
            this.toastr.error(res.message);
          }
          return;
        }

        // Store the full client list from backend
        this.clientList = res.data || [];

        const userSessionData = JSON.parse(
          sessionStorage.getItem("userSession")
        );
        const userRoleId = userSessionData.user_role_id[0];
        if (userRoleId == 1) {
          this.isAdmin = true;
        }
        // If non-admin, filter clientList by allowed clients
        const hasFullAccess = userRoleId === 1 || userRoleId === 7;

        if (!hasFullAccess && userSessionData.clientList?.length) {
          const allowedEmails = userSessionData.clientList;
          this.clientList = this.clientList.filter((item) =>
            allowedEmails.includes(item.clientEmail)
          );
        }

        // Fetch invoices after clientList is ready
        this.superAdminService
          .getInvoice()
          .subscribe((invoices: { status: any; message: any; data: any }) => {
            this.spinner.hide();

            if (invoices.status !== true) {
              if (invoices.status == 401) {
                this.toastr.error(invoices.message);
                sessionStorage.clear();
                this.router.navigateByUrl("superAuth/login");
              } else {
                this.toastr.error(invoices.message);
              }
              return;
            }

            this.invoiceList = invoices.data || [];

            console.log({ invoiceList: this.invoiceList })
            const temp = [];

            // Map invoices to displayable client names
            this.invoiceList.forEach((x) => {
              const matchedClient = this.clientList.find(
                (c) => c && c._id?.toString() === x.clientId?.toString()
              );

              temp.push({
                billNumber: x.billNo || "-",
                clientName: matchedClient?.clientName || "Unknown Client",
                date: x.created_date.split("T")[0],
                _id: x._id,
                created_date: x.created_date,
              });

              // Handle invoices generated by TripID
              if (x.TripID) {
                temp.push({
                  TripId: x.TripID,
                  clientName: "Generated By Trip",
                  date: x.created_date.split("T")[0],
                  _id: x._id,
                  created_date: x.created_date,
                });
              }
            });

            this.clientName = temp;
            this.dataSource = new MatTableDataSource(this.clientName);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
      });
  }

  getInvoiceTypes() {
    this.superAdminService
      .getInvoiceTypes()
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.invoiceType = rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      });
  }


  getlrs() {
    this.receipts = [];
    this.superAdminService
      .getlrs()
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.receipts = rawdata.sort(function (a: any, b: any) {
            return (
              <any>new Date(b.receipt.created_date) -
              <any>new Date(a.receipt.created_date)
            );
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      });
  }
  getlrsbynames(email) {
    this.superAdminService
      .getlrsbyClientId(email)
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          // this.receipts = rawdata;
          this.lrByEmail = rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      });
  }
  getObjectListFromData(ids) {
    return this.lrNumber.filter((item) => ids.includes(item.item_id));
  }


  generateInvoicePreview() {
    this.extractLrNoFromActualData = [];

    const lrSelection: any[] = Array.isArray(this.filterform.value.LR_no)
      ? this.filterform.value.LR_no
      : [];

    this.extractLrNoFromActualData = lrSelection.map(
      (item: any) => item.item_text
    );

    if (!this.filterform.valid) {
      this.toastr.warning("Please fill all the required fields in the form.");
      return;
    }

    const selectedClient = this.clientList.find(
      (c: any) => c._id === this.filterform.value.clientName
    );

    if (!selectedClient) {
      this.toastr.error("Please select a valid client!");
      return;
    }

    const form = {
      clientId: selectedClient._id,
      invoiceType: this.filterform.value.invoiceType,
      LR_no: this.extractLrNoFromActualData,
    };


    this.superAdminService.generateInvoicePreview({ form }).subscribe(
      (res: any) => {
        if (res.status) {
          console.log(res.data)
          this.invoicePreviewRef = this.dialog.open(InvoicePreviewComponent, {
            data: {
              invoiceData: res.data,
              invoiceType: this.filterform.value.invoiceType
            },
            disableClose: true,
            width: '67%',
            height: 'auto',
            maxHeight: '90vh',
            panelClass: 'custom-border-radius'
          });

          this.invoicePreviewRef.afterClosed().subscribe((result: { status: "approved" | "declined", billno?: string }) => {
            console.log(result, "result coming after dialog closed")

            if ("status" in result) {

              if (result.status == "approved") {
                this.generateInvoice(result.billno)
                // this.toastr.success("Invoice approved successfully");

              } else {
                this.filterform.reset()
                this.lrNumber = []
                this.toastr.error("Invoice declined");
              }
            }
          });
        } else {
          this.toastr.error(res.message);
        }
      },
      () => this.toastr.error("Something went wrong")
    );
  }

  generateInvoice(billNo?: string) {
    this.extractLrNoFromActualData = [];

    const lrSelection: any[] = Array.isArray(this.filterform.value.LR_no)
      ? this.filterform.value.LR_no
      : [];

    this.extractLrNoFromActualData = lrSelection.map(
      (item: any) => item.item_text
    );

    if (!this.filterform.valid) {
      return;
    }

    const selectedClient = this.clientList.find(
      (c: any) => c._id === this.filterform.value.clientName
    );

    if (!selectedClient) {
      this.toastr.error("Please select a valid client!");
      return;
    }

    const form = {
      billNo: billNo,
      clientId: selectedClient._id,
      invoiceType: this.filterform.value.invoiceType,
      LR_no: this.extractLrNoFromActualData,
    };

    this.superAdminService.generateInvoice({ form }).subscribe(
      (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.getClientList();
          this.getlrs();
        } else {
          this.toastr.error(res.message);
        }
      },
      () => this.toastr.error("Something went wrong")
    );
  }

  onItemSelect($event: any) {
    this.onFocusGetLr($event);
  }

  async onFocusGetLr(event: any) {
    let id = event.target.value;
    this.superAdminService
      .getlrsbyClientId(id)
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          rawdata = rawdata.filter((item) => item.clientId);
          this.EmailLr = [];
          rawdata.map((x) => {
            this.EmailLr.push(x.LR_no);
            // this.EmailLr.push(x.manualLR_no);
          });

          this.generatedLrs = [];
          this.invoiceList.map((x) => {
            x.invoice.map((y) => {
              this.generatedLrs.push(y.LR_no);
            });
          });

          this.genLr = [];

          for (let i = 0; i < this.generatedLrs.length; i++) {
            for (let j = 0; j < this.generatedLrs[i].length; j++) {
              this.genLr.push(this.generatedLrs[i][j]);
            }
          }

          let temp = [];
          for (let i = 0; i < this.EmailLr.length; i++) {
            var bool = false;
            for (let j = 0; j < this.genLr.length; j++) {
              if (this.EmailLr[i] == this.genLr[j]) {
                bool = true;
              }
            }
            if (bool == false) {
              temp.push({
                item_id: this.EmailLr[i],
                item_text: this.EmailLr[i],
              });
            }
          }
          this.lrNumber = temp;

          this.dropdownSettings = {
            singleSelection: false,
            idField: "item_id",
            textField: "item_text",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
          };
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      });
  }
  backTo() {
    window.history.back();
  }
  addvalidatorcss(id: string) {
    // document.getElementById(id).classList.add('validatorcss');
  }
  removevalidatorcss(id: string) {
    // document.getElementById(id).classList.remove('validatorcss');
  }
  deleteInvoice(_id) {
    if (this.superAdminService.deleteDailogBox()) {
      this.superAdminService.deleteInvoice(_id).subscribe(
        (res: { status: any; message: any; authorization: any; code: any }) => {
          if (res.status == true) {
            this.toastr.success(res.message);
            // this.ngOnInit();
            this.ngOnInit();
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        },
        (error) => { }
      );
    }
  }
  getFreight(user: any, i: number): string {
    if (user?.Frieght && user.Frieght[i] !== undefined && user.Frieght[i] !== null && user.Frieght[i] !== '') {
      return user.Frieght[i];
    }
    if (user?.freight && user.freight[i] !== undefined && user.freight[i] !== null && user.freight[i] !== '') {
      return user.freight[i];
    }
    return '-';
  }

  getAdhocLineAmount(user: any, index: number): number {
    const amount = (value: any) => Number(Array.isArray(value) ? value[index] || 0 : value || 0);
    return amount(user?.Frieght ?? user?.freight)
      + amount(user?.labourLoad)
      + amount(user?.labourUnload)
      + amount(user?.otherPayment)
      + amount(user?.detention);
  }

  getVehicleType(user: any, i: number): string {
    return user?.vehicle_type?.[i] || user?.vehicleType?.[i] || '-';
  }

  recalculateTotals() {
    this.kmtot = 0;
    this.extrahour = 0;
    this.tooltaxPaidtot = 0;
    this.invtot = 0;
    this.totLabourLoad = 0;
    this.totLabourUnload = 0;
    this.totDetention = 0;
    this.Frieght = 0;
    this.otherPayment = 0;

    if (!Array.isArray(this.users)) return;

    this.users.forEach((user: any) => {
      if (!user) return;

      this.invtot += (Array.isArray(user.vehicleRate) ? user.vehicleRate : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.kmtot += (Array.isArray(user.up_down_km) ? user.up_down_km : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.extrahour += (Array.isArray(user.extrahour) ? user.extrahour : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.tooltaxPaidtot += (Array.isArray(user.tooltaxPaid) ? user.tooltaxPaid : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.totLabourLoad += (Array.isArray(user.labourLoad) ? user.labourLoad : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.totLabourUnload += (Array.isArray(user.labourUnload) ? user.labourUnload : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.totDetention += (Array.isArray(user.detention) ? user.detention : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.otherPayment += (Array.isArray(user.otherPayment) ? user.otherPayment : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);

      this.Frieght += (Array.isArray(user.Frieght) ? user.Frieght : [])
        .reduce((a: number, b: any) => a + Number(b || 0), 0);
    });

    if (this.isAdHoc) {
      this.totalAmountInAdhoc =
        this.totDetention +
        // this.invtot +
        this.totLabourLoad +
        this.totLabourUnload +
        this.Frieght +
        this.otherPayment;
    }
  }

  loadTransporterDetails() {
    const firstUser = this.users[0];
    if (!firstUser) {
      this.transporterName = 'Radha Swami Transport Service';
      this.transporterAddress = 'N/A';
      this.transporterGstNo = 'N/A';
      return;
    }

    const toArray = (val: any): any[] => {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      if (typeof val === 'string' || typeof val === 'number') return [val];
      return [];
    };

    const rawTransporterNames = toArray(firstUser.transportorName);
    const validTransporterName = rawTransporterNames.find((name: any) =>
      name && name !== '0' && name !== '1' && name !== '-' && String(name).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.transportorName === 'string' ? firstUser.transportorName : '') || '';

    const rawGstins = toArray(firstUser.GSTIN);
    const validGstin = rawGstins.find((gst: any) =>
      gst && gst !== '0' && gst !== '1' && gst !== '-' && String(gst).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.GSTIN === 'string' ? firstUser.GSTIN : '') || '';

    const rawAddresses = [
      ...toArray(firstUser.consignor_address),
      ...toArray(firstUser.consignee_address)
    ];
    const validAddress = rawAddresses.find((addr: any) =>
      addr && addr !== '0' && addr !== '1' && addr !== '-' && String(addr).toLowerCase() !== 'n/a'
    ) || (typeof firstUser.consignor_address === 'string' ? firstUser.consignor_address : '')
      || (typeof firstUser.consignee_address === 'string' ? firstUser.consignee_address : '')
      || '';

    this.transporterName = validTransporterName && validTransporterName !== '0' && validTransporterName !== '1'
      ? validTransporterName
      : 'Radha Swami Transport Service';
    this.transporterAddress = validAddress || 'N/A';
    this.transporterGstNo = validGstin && validGstin !== '0' && validGstin !== '1' ? validGstin : 'N/A';

    this.superAdminService.getAllTransporters(1, 1000).subscribe({
      next: (res: any) => {
        if (res?.status && Array.isArray(res?.data) && res.data.length > 0) {
          const list = res.data;

          const matched = list.find((t: any) => {
            const fullName = (t.user_id?.full_name || '').trim().toLowerCase();
            const tpId = (t.transporter_id || '').trim().toLowerCase();
            const gstin = (t.gstin || '').trim().toLowerCase();

            const targetName = String(validTransporterName).trim().toLowerCase();
            const targetGst = String(validGstin).trim().toLowerCase();

            return (targetName && (fullName === targetName || tpId === targetName)) ||
              (targetGst && gstin === targetGst);
          });

          if (matched) {
            this.setTransporterFromRecord(matched);
            return;
          }

          // Check if vehicle connects to a transporter
          const vehicleNo = Array.isArray(firstUser.vehicle_id) ? firstUser.vehicle_id[0] : firstUser.vehicle_id;
          if (vehicleNo) {
            this.superAdminService.getvehicles().subscribe({
              next: (vRes: any) => {
                if (vRes?.status && Array.isArray(vRes?.data)) {
                  const matchedVehicle = vRes.data.find((v: any) => v.vehicle_no === vehicleNo);
                  if (matchedVehicle && matchedVehicle.transporter) {
                    const t = list.find((item: any) => item._id === matchedVehicle.transporter);
                    if (t) {
                      this.setTransporterFromRecord(t);
                    }
                  }
                }
              },
              error: (err: any) => {
                console.warn("Could not load vehicles for transporter lookup:", err);
              }
            });
          }
        }
      },
      error: (err: any) => {
        console.warn("Error loading transporters:", err);
      }
    });
  }

  private setTransporterFromRecord(t: any) {
    if (t.user_id?.full_name) {
      this.transporterName = t.user_id.full_name;
    }
    if (t.gstin) {
      this.transporterGstNo = t.gstin;
    }
    const addressParts = [
      t.address_line_1,
      t.address_line_2,
      t.city,
      t.state,
      t.pin_code
    ].filter((part: any) => part && String(part).trim().length > 0);

    if (addressParts.length > 0) {
      this.transporterAddress = addressParts.join(', ');
    }
  }

  setupInvoiceData(rawdata: any) {
    let list: any[] = [];
    if (Array.isArray(rawdata)) {
      list = rawdata;
    } else if (rawdata && typeof rawdata === 'object') {
      list = [rawdata];
    }
    const firstRecord = list[0] || {};

    const rawInvType = firstRecord?.invoiceType
      || firstRecord?.invoiceTypeName
      || (Array.isArray(firstRecord?.invoice?.[0]?.invoiceTypeName) ? firstRecord?.invoice?.[0]?.invoiceTypeName?.[0] : firstRecord?.invoice?.[0]?.invoiceTypeName)
      || (Array.isArray(firstRecord?.invoice?.[0]?.fixAdhoc) ? firstRecord?.invoice?.[0]?.fixAdhoc?.[0] : firstRecord?.invoice?.[0]?.fixAdhoc)
      || firstRecord?.fixAdhoc
      || firstRecord?.invoice?.[0]?.invoiceType
      || '';

    this.isAdHoc = /adhoc/i.test(rawInvType)
      || /ad hoc/i.test(rawInvType)
      || rawInvType === 'Type1'
      || rawInvType === 'Type 1'
      || !rawInvType;

    this.checkInvoiceType = rawInvType || (this.isAdHoc ? 'Ad Hoc' : 'Fixed');
    this.billno = firstRecord?.billno || firstRecord?.billNo || '';

    const rawInvoice = firstRecord?.invoice || firstRecord?.invoiceData;
    if (Array.isArray(rawInvoice)) {
      this.users = rawInvoice;
    } else if (rawInvoice && typeof rawInvoice === 'object') {
      this.users = [rawInvoice];
    } else if (Array.isArray(firstRecord)) {
      this.users = firstRecord;
    } else {
      this.users = [];
    }

    this.users.forEach((user: any) => {
      if (!user) return;
      const lrCount = Array.isArray(user.LR_no) ? user.LR_no.length : (user.LR_no ? 1 : 0);
      if (!Array.isArray(user.labourLoad)) user.labourLoad = new Array(lrCount).fill(0);
      if (!Array.isArray(user.labourUnload)) user.labourUnload = new Array(lrCount).fill(0);
      if (!Array.isArray(user.detention)) user.detention = new Array(lrCount).fill(0);
    });

    this.Frieght = Array.isArray(this.users[0]?.Frieght)
      ? this.users[0]?.Frieght?.[0]
      : (this.users[0]?.Frieght || 0);

    this.recalculateTotals();
    this.loadTransporterDetails();
  }

  getParticularInvoice(id: string) {
    this.superAdminService.getParticularInvoice(id).subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.setupInvoiceData(rawdata);
          setTimeout(() => {
            let printBtn: HTMLElement = this.printBtn.nativeElement;
            printBtn.click();
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => { }
    );
  }

  sendInvoice(divName, Id) {
    this.superAdminService.getParticularInvoice(Id).subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.setupInvoiceData(rawdata);
          // send invoice begins
          setTimeout(() => {
            var data = document.getElementById(divName);
            data.style.display = "block";
            html2canvas(data).then((canvas) => {
              var imgWidth = 208;
              var imgHeight = (canvas.height * imgWidth) / canvas.width;
              const contentDataURL = canvas.toDataURL("image/png", 0.3);
              let pdf = new jsPDF("p", "mm", "a4");
              pdf.addImage(
                contentDataURL,
                "PNG",
                1,
                1,
                imgWidth,
                imgHeight,
                undefined,
                "FAST"
              );
              let binary = pdf.output();
              data.style.display = "none";
              binary = binary ? btoa(binary) : "";
              this.superAdminService.sendInvoice(Id, binary).subscribe(
                (res: any) => {
                  if (res.status == true) {
                    this.toastr.success(res.message);
                  } else {
                    if (res.status == 401) {
                      this.toastr.error(res.message);
                      window.sessionStorage.clear();
                      this.router.navigateByUrl("superAuth/login");
                    } else {
                      this.toastr.error(res.message);
                    }
                  }
                },
                (error) => { }
              );
            });
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => { }
    );
  }
  filterData(value) {
    this.dataSource.filter = value;
  }
  sortData(sort: Sort) {
    const data = this.dataSource.filteredData;
    if (!sort.active || sort.direction === "") {
      return this.dataSource;
    }
    this.dataSource.filteredData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "clientName":
          return compare(lower(a.clientName), lower(b.clientName), isAsc);
        case "created_date":
          return compare(a.created_date, b.created_date, isAsc);
        default:
          return 0;
      }
    });
    function compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    function lower(value) {
      return value ? value.toLowerCase() : value;
    }
  }
}
